import { EmptySection } from "../EmptySection";
import { ScheduleData, ScheduleList } from "./ScheduleList";

import Styles from "./ScheduleListContainer.module.scss";
import { UUID } from "src/utils/uuid";
import { Title } from "src/components/atoms/Title/Title";
import { OldGrid } from "src/components/atoms/OldGrid/OldGrid";
import { OldRow } from "src/components/atoms/OldGrid/OldRow";

type ScheduleListContainerProps<T extends UUID<string>> = {
  scheduleData: ScheduleData<T>[];
};

export function ScheduleListContainer<T extends UUID<string>>(props: ScheduleListContainerProps<T>) {
  const isScheduleEmpty = props.scheduleData.length === 0;
  return (
    <OldGrid className={Styles.schedulePageContainer}>
      <OldRow className={Styles.scheduleHeader}>
        <Title text={"Schedule"} className={isScheduleEmpty ? Styles.scheduleHeaderEmpty : Styles.scheduleHeaderRow}>
          &nbsp;
        </Title>
      </OldRow>

      <OldRow>
        {isScheduleEmpty ? (
          <EmptySection iconType={"schedule"} message={"No Events Scheduled"} />
        ) : (
          <ScheduleList scheduleData={props.scheduleData} />
        )}
      </OldRow>
    </OldGrid>
  );
}
